import { __assign } from "tslib";
// DS: C60
import React, { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import { PureBiData } from '@wix/da-bi/pkg/events';
import { useEventValueCallback } from '@wix/da-hooks/pkg/useEventValueCallback';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import noop from '../../../../utils/noop';
import Button from '../../../../Button';
import { useDeviationDownloads } from '../permissions';
import PremiumAssetList from './PremiumAssetList';
import FreeDownloadOption from './DownloadOptions/FreeDownloadOption';
import PremiumDownloadOption from './DownloadOptions/PremiumDownloadOption';
import s from './DownloadPopover.scss';
var logger = ddt.createLogger('downloadbutton');
export var DownloadType;
(function (DownloadType) {
    DownloadType["FREE"] = "free";
    DownloadType["PREMIUM"] = "premium";
})(DownloadType || (DownloadType = {}));
var DownloadPopover = function (_a) {
    var _b, _c, _d;
    var deviation = _a.deviation, _e = _a.closeTooltip, closeTooltip = _e === void 0 ? noop : _e, _f = _a.onDownload, onDownload = _f === void 0 ? noop : _f;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var downloadsAndPermissions = useDeviationDownloads(deviation);
    var freeDownload = downloadsAndPermissions.freeDownload, freeDownloadPermission = downloadsAndPermissions.freeDownloadPermission, premiumDownload = downloadsAndPermissions.premiumDownload, premiumDownloadPermission = downloadsAndPermissions.premiumDownloadPermission;
    var includeFreeDownload = freeDownload && freeDownloadPermission !== 'blocked_by_subscription';
    var _g = useState(includeFreeDownload ? DownloadType.FREE : DownloadType.PREMIUM), selectedType = _g[0], setSelectedType = _g[1];
    var onOptionSelect = useEventValueCallback(function (value) { return setSelectedType(value); }, [setSelectedType]);
    var isDownloadable = false;
    var buttonHref;
    var buttonText;
    if (selectedType === DownloadType.FREE) {
        isDownloadable = freeDownloadPermission === 'downloadable';
        var tierAuthor = (_b = deviation.primaryTier) === null || _b === void 0 ? void 0 : _b.author;
        var subscriptionsTabUrl = tierAuthor && Url.userLink(tierAuthor.username, '/subscriptions');
        buttonHref = isDownloadable ? freeDownload === null || freeDownload === void 0 ? void 0 : freeDownload.url : subscriptionsTabUrl;
        buttonText = t(isDownloadable
            ? 'actionbar.download.downloadNow'
            : 'actionbar.download.mustSubscribe');
    }
    else if (selectedType === DownloadType.PREMIUM) {
        var doesntNeedToPurchase = premiumDownloadPermission === 'downloadable';
        isDownloadable = doesntNeedToPurchase;
        var checkoutUrl = ((_c = deviation.pcp) === null || _c === void 0 ? void 0 : _c.subproductId)
            ? Url.checkoutLink((_d = deviation.pcp) === null || _d === void 0 ? void 0 : _d.subproductId)
            : undefined;
        buttonHref = isDownloadable ? premiumDownload === null || premiumDownload === void 0 ? void 0 : premiumDownload.url : checkoutUrl;
        buttonText = t(isDownloadable
            ? 'actionbar.download.downloadNow'
            : 'actionbar.download.mustPurchase');
    }
    logger.log('DownloadPopover', {
        isDownloadable: isDownloadable,
        buttonText: buttonText,
        buttonHref: buttonHref,
    });
    var handleClick = useCallback(function (e) {
        isDownloadable && onDownload();
        closeTooltip(e);
    }, [isDownloadable, onDownload, closeTooltip]);
    if (!premiumDownload) {
        logger.log('DownloadPopover, no premiumDownload');
        return null;
    }
    var contents = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['title'] }, t('actionbar.download.downloadDeviation')),
        React.createElement("div", { className: s['options'] },
            includeFreeDownload && (React.createElement(FreeDownloadOption, { freeDownload: freeDownload, checked: selectedType === 'free', onSelect: onOptionSelect })),
            React.createElement(PremiumDownloadOption, { deviation: deviation, checked: selectedType === 'premium', onSelect: onOptionSelect })),
        React.createElement(PremiumAssetList, { assets: premiumDownload.assets, muted: selectedType !== DownloadType.PREMIUM }),
        React.createElement(Button, __assign({ view: "b18", className: s['download-button'], disabled: selectedType === undefined, href: buttonHref }, (isDownloadable && {
            target: '_blank',
            download: true,
        }), { onClick: handleClick, biData: PureBiData({
                evid: 351,
                deviationid: deviation.deviationId,
            }) }), buttonText)));
    return isMobile ? (React.createElement(DSModal, { isOpen: true, onRequestClose: closeTooltip, heading: includeFreeDownload
            ? t('actionbar.download.mobile.freeAndPremiumDownload')
            : t('actionbar.download.mobile.premiumDownload'), contentClassName: s['root'], showHeaderBorder: true }, contents)) : (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
        React.createElement("div", { className: s['root'] }, contents)));
};
DownloadPopover.displayName = 'DownloadPopover';
export default DownloadPopover;
//# sourceMappingURL=DownloadPopover.js.map